import { useState, useEffect } from "react";
import { XCircleIcon } from "@heroicons/react/solid";
import { classNames } from "../../helpers";

type FileProps = {
  title?: string;
  subTitle?: string;
  icon?: any;
  color?: string;
  onClose?: any;
  fileUploaded?: any;
  signedId?: string;
};

export default function FileListView({
  title,
  subTitle,
  icon,
  color,
  signedId,
  onClose,
  fileUploaded,
}: FileProps) {
  const [fileStatus, setFileStatus] = useState<any>(null);
  useEffect(() => {
    setFileStatus(fileUploaded);
  }, [fileUploaded]);
  return (
    <>
      {fileStatus !== null && (
        <div>
          <div className="my-4 w-full flex shadow-sm rounded-md">
            {!!icon && (
              <a
                rel="noopener"
                href={`${process.env.REACT_APP_API_URL}rails/active_storage/blobs/redirect/${signedId}/${title}`}
                target="_blank"
                className={classNames(
                  `${color}`,
                  "flex-shrink-0 h-16 flex items-center justify-center w-16 text-white text-sm font-medium rtl:rounded-r-md ltr:rounded-l-md"
                )}
              >
                {icon}
              </a>
            )}
            <div className="flex-1 flex items-center justify-between border-t rtl:border-l ltr:border-r border-b border-gray-200 bg-white rounded-r-md truncate">
              {/* // TODO move the preview url to env variables */}
              <a
                rel="noopener"
                href={`${process.env.REACT_APP_API_URL}rails/active_storage/blobs/redirect/${signedId}/${title}`}
                target="_blank"
                className="flex-1 px-4 py-2 text-sm truncate"
              >
                <div className="text-gray-900 font-medium hover:text-gray-600">
                  {title}
                </div>
                <p className="text-gray-500">{subTitle}</p>
              </a>

              {!!onClose && (
                <div className="flex-shrink-0 rtl:pl-2 ltr:pr-2">
                  <button
                    onClick={() => {
                      onClose();
                    }}
                    type="button"
                    data-cy={"cancel-icon"}
                    className="w-8 h-8 bg-white inline-flex items-center justify-center text-gray-400 rounded-full bg-transparent hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandblue-500"
                  >
                    <span className="sr-only">Open options</span>
                    <XCircleIcon className="w-5 h-5" aria-hidden="true" />
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
